module.exports = __webpack_public_path__ + "static/media/1825010.79bffc6c.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/elections/us/GeoData/1825010.geojson
// module id = 324
// module chunks = 0